

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectPage } from '../../../project.page';
import { DxButtonModule, DxChartModule, DxDataGridModule } from 'devextreme-angular';
import { Router, RouterModule } from '@angular/router';
import { ProjectCostsService } from 'src/app/services/project-costs.service';
import { AppGlobals } from 'src/app/app.globals';
@Component({
    selector: 'app-project-costs-controlling',
    imports: [
        CommonModule,
        DxButtonModule,
        RouterModule,
        DxChartModule,
        DxDataGridModule
    ],
    providers: [ProjectPage],
    templateUrl: './project-costs-controlling.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-costs-controlling.page.css']
})

export class ProjectCostsControllingPageComponent implements OnInit {
    currentPhaseId: number | null = null;

    chartData: any = [
        { category: 'Category 1', regularCost: 4500, paidAmount: 3000, outstandingCost: 2000 },
        { category: 'Category 2', regularCost: 8000, paidAmount: 4000, outstandingCost: 1000 },
        { category: 'Category 3', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 4', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 5', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 6', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 7', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 8', regularCost: 6000, paidAmount: 3500, outstandingCost: 1500 },
        { category: 'Category 9', regularCost: 10000, paidAmount: 3500, outstandingCost: 6500 },
    ];
    totalChartData: any = []
    totalsChartSize: any = {
        width: 400
    }
    amountAxisTitle = $localize`:@@amountEuro:Amount (Nett, €)`;
    budgetDataTitle = $localize`:@@budgetData:Budget Data`;
    costDataTitle = $localize`:@@costData:Cost Data`;
    totalsTitle = $localize`:@@totals:Totals`;
    subcategoryTitle = $localize`:@@Subcategory:Subcategory: `;
    categoryCostTitle = $localize`:@@PrimaryCategoryCostBreakdown:Primary Category Cost Breakdown`;
    totalcostsTitle = $localize`:@@TotalProjectCosts:Total Project Costs`;


    primaryChartData: any = []
    subCatChartData: any = []
    maxValue: number | null = null;
    categoryList = ['Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5', 'Category 6', 'Category 7', 'Category 8', 'Category 9'];
    selectedCost: any | null = null;
    selectedCategory: any | null = null;
    selectedSubCategory: any | null = null;
    selectedCostData: object | null = [
        {
            id: 0,
            costName: 'Test Cost 1',
            paidAmount: '100',
            outstandingAmount: '100',
            regularCost: '200',
            dueDate: new Date(),
        },
        {
            id: 1,
            costName: 'Test Cost 2',
            paidAmount: '900',
            outstandingAmount: '100',
            regularCost: '1000',
            dueDate: new Date(),
        },
        {
            id: 2,
            costName: 'Test Cost 3',
            paidAmount: '200',
            outstandingAmount: '300',
            regularCost: '500',
            dueDate: new Date(),
        },

    ];

    showSubCatGridVisible: boolean = false;
    constructor(
        private projectCostService: ProjectCostsService,
        private router: Router
    ) { }

    ngOnInit(): void {

        this.getControllingData();
        let totals = {
            category: 'Totals',
            regularCost: null,
            paidAmount: null,
            outstandingCost: null
        }
        for (let i = 0; i < this.chartData.length; i++) {
            this.chartData[i].outstandingCost = this.chartData[i].outstandingCost + this.chartData[i].paidAmount;
            totals.regularCost = totals.regularCost + this.chartData[i].regularCost;
            totals.paidAmount = totals.paidAmount + this.chartData[i].paidAmount;
            totals.outstandingCost = totals.outstandingCost + this.chartData[i].outstandingCost;
        }
        this.totalChartData.push(totals);
        this.maxValue = this.getMaxValue(this.chartData);
    }

    customizeTooltip = ({ valueText, seriesName }) => ({
        text: `${seriesName}: ${valueText}`,
    });


    getControllingData(): void {

        let url = this.router.url;
        let splitUrl = url.split('/')
        console.log('splitUrl', splitUrl[4])
        let ProjectId = splitUrl[4];


        this.projectCostService.getProjectControllingData({ ProjectId }).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {


                // POPULATE DATA FOR TOTALS CHART
                let totalChartNumbers = {
                    totalCostCategoryBudgetNett: result.controllingData.totals.totalCostCategoryBudgetNett,
                    totalCostCategoryPlanNett: result.controllingData.totals.totalCostCategoryPlanNett,
                    totalCostCategoryPlanNettBeauftragt: result.controllingData.totals.totalCostCategoryPlanNettBeauftragt,
                    totalCostCategoryPaidNett: result.controllingData.totals.totalCostCategoryPaidNett,
                    projectCostCategoryName: result.controllingData.totals.projectCostCategoryName
                };
                this.totalChartData.push(totalChartNumbers);

                // POPULATE DATA FOR PRIMARY CATEGORY CHART
                this.primaryChartData = result.controllingData.primaryCategories;

            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }

    openCategoryDetails(e: any): void {
        console.log('openCategoryDetails', e);;
        for (let i = 0; i < this.primaryChartData.length; i++) {
            if (this.primaryChartData[i].projectCostCategoryName === e.argument) {
                this.selectedCategory = this.primaryChartData[i];
                console.log('this.selectedCategory', this.selectedCategory)
                this.subCatChartData = this.selectedCategory.subCategories;
            }
        }
    }

    openSubCategoryDetails(e: any): void {
        console.log('openSubCategoryDetails', e);
        this.showSubCatGridVisible = true;
        for (let i = 0; i < this.subCatChartData.length; i++) {
            if (this.subCatChartData[i].projectCostCategoryName === e.argument) {
                this.selectedSubCategory = this.subCatChartData[i];
                console.log('this.selectedSubCategory', this.selectedSubCategory)
                //this.subCatChartData = this.selectedCost.subCategories;
            }
        }

    }

    getMaxValue(data: any[]): number {
        let maxValues = data.map(item => Math.max(item.regularCost, item.paidAmount, item.outstandingCost));
        console.log(Math.max(...maxValues))
        return Math.max(...maxValues);
    }

    showSubCatGrid(): void {
        this.showSubCatGridVisible = !this.showSubCatGridVisible;
    }

    onPrimaryCatBarClick(e: any): void {
        console.log(e.target.data);
        for (let i = 0; i < this.primaryChartData.length; i++) {
            if (this.primaryChartData[i].projectCostCategoryName === e.target.data.projectCostCategoryName) {
                this.selectedCategory = this.primaryChartData[i];
                console.log('this.selectedCategory', this.selectedCategory)
                this.subCatChartData = this.selectedCategory.subCategories;
            }
        }
    }

    onSubCatBarClick(e: any): void {
        console.log('openSubCategoryDetails', e);
        this.showSubCatGridVisible = true;
        for (let i = 0; i < this.subCatChartData.length; i++) {
            if (this.subCatChartData[i].projectCostCategoryName === e.target.data.projectCostCategoryName) {
                this.selectedSubCategory = this.subCatChartData[i];
                console.log('this.selectedSubCategory', this.selectedSubCategory)
                //this.subCatChartData = this.selectedCost.subCategories;
            }
        }
    }
}
